<template>
  <div class="mapaSection">
    <div
      class="iniWindow"
      :class="mainModalClass"
    >
      <div class="mapIconCol" />

      <div class="textCol">
        <div class="headerCol">
          <h1>{{ $t("txt.headerOne") }}</h1>
        </div>
        <div class="bodyCol">
          <div class="descCol">
            <h3>{{ $t("txt.headerThree") }}</h3>
            <p>{{ $t("txt.paraMain") }}</p>
          </div>
          <div class="tableCol">
            <table class="table text-black table-bordered">
              <caption>
                {{ $t("txt.tableCaption") }}
                <strong>2020</strong>
              </caption>
              <thead>
                <tr>
                  <th>
                    &nbsp;
                  </th>
                  <th
                    colspan="2"
                    class="eqw"
                  >
                    {{ $t("txt.populationTotal") }}
                  </th>
                  <th
                    colspan="2"
                    class="eqw"
                  >
                    {{ $t("txt.origTotalExt") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    &nbsp;
                  </td>
                  <td>
                    ABS.
                  </td>
                  <td>
                    %
                  </td>
                  <td>
                    ABS.
                  </td>
                  <td>
                    %
                  </td>
                </tr>
                <tr class="inv">
                  <td class="tl inv">
                    {{ $t("txt.totalEuz") }}
                  </td>
                  <td class="tc inv">
                    2.157.279
                  </td>
                  <td class="tc inv">
                    100,0
                  </td>
                  <td class="tc inv">
                    213.510
                  </td>
                  <td class="tc inv">
                    100,0
                  </td>
                </tr>
                <tr>
                  <td class="tl">
                    {{ $t("txt.cat") }}
                  </td>
                  <td class="tc">
                    1.489.864
                  </td>
                  <td class="tc">
                    69,1
                  </td>
                  <td class="tc">
                    96.010
                  </td>
                  <td class="tc">
                    45,0
                  </td>
                </tr>
                <tr>
                  <td class="tl">
                    {{ $t("txt.pro") }}
                  </td>
                  <td class="tc">
                    29.326
                  </td>
                  <td class="tc">
                    1,4
                  </td>
                  <td class="tc">
                    23.326
                  </td>
                  <td class="tc">
                    10,9
                  </td>
                </tr>
                <tr>
                  <td class="tl">
                    {{ $t("txt.ort") }}
                  </td>
                  <td class="tc">
                    18.964
                  </td>
                  <td class="tc">
                    0,9
                  </td>
                  <td class="tc">
                    18.964
                  </td>
                  <td class="tc">
                    8,9
                  </td>
                </tr>
                <tr>
                  <td class="tl">
                    {{ $t("txt.tes") }}
                  </td>
                  <td class="tc">
                    4532
                  </td>
                  <td class="tc">
                    0,2
                  </td>
                  <td class="tc">
                    250
                  </td>
                  <td class="tc">
                    0,1
                  </td>
                </tr>
                <tr>
                  <td class="tl">
                    {{ $t("txt.jes") }}
                  </td>
                  <td class="tc">
                    1700
                  </td>
                  <td class="tc">
                    0,1
                  </td>
                  <td class="tc">
                    150
                  </td>
                  <td class="tc">
                    0,1
                  </td>
                </tr>
                <tr>
                  <td class="tl">
                    {{ $t("txt.mus") }}
                  </td>
                  <td class="tc">
                    89.487
                  </td>
                  <td class="tc">
                    4,1
                  </td>
                  <td class="tc">
                    47.790
                  </td>
                  <td class="tc">
                    22,4
                  </td>
                </tr>
                <tr>
                  <td class="tl">
                    {{ $t("txt.jud") }}
                  </td>
                  <td class="tc">
                    259
                  </td>
                  <td class="tc">
                    0,0
                  </td>
                  <td class="tc">
                    259
                  </td>
                  <td class="tc">
                    0,1
                  </td>
                </tr>
                <tr>
                  <td class="tl">
                    {{ $t("txt.hin") }}
                  </td>
                  <td class="tc">
                    955
                  </td>
                  <td class="tc">
                    0,0
                  </td>
                  <td class="tc">
                    955
                  </td>
                  <td class="tc">
                    0,4
                  </td>
                </tr>
                <tr>
                  <td class="tl">
                    {{ $t("txt.bud") }}
                  </td>
                  <td class="tc">
                    1591
                  </td>
                  <td class="tc">
                    0,1
                  </td>
                  <td class="tc">
                    1591
                  </td>
                  <td class="tc">
                    0,7
                  </td>
                </tr>
                <tr>
                  <td class="tl">
                    {{ $t("txt.ani") }}
                  </td>
                  <td class="tc">
                    3434
                  </td>
                  <td class="tc">
                    0,2
                  </td>
                  <td class="tc">
                    3434
                  </td>
                  <td class="tc">
                    1,6
                  </td>
                </tr>
                <tr>
                  <td class="tl">
                    {{ $t("txt.otr") }}
                  </td>
                  <td class="tc">
                    610
                  </td>
                  <td class="tc">
                    0,0
                  </td>
                  <td class="tc">
                    610
                  </td>
                  <td class="tc">
                    0,3
                  </td>
                </tr>
                <tr>
                  <td class="tl">
                    {{ $t("txt.no") }}
                  </td>
                  <td class="tc">
                    515.771
                  </td>
                  <td class="tc">
                    23,9
                  </td>
                  <td class="tc">
                    19.384
                  </td>
                  <td class="tc">
                    9,1
                  </td>
                </tr>
              </tbody>
            </table>
            <Button
              class="bg-purple-700 hover:bg-purple-500 mt-3 text-white uppercase w-100"
              @click="hideMainModal()"
            >
              {{ $t("txt.showMap") }}
            </Button>
          </div>
        </div>
        <div class="logoCol">
          <div class="origami" />
          <div class="euskojaularitza" />
          <div class="ikuspegi" />
        </div>
      </div>
    </div>
    <div class="sideBar">
      <div class="sideContent">
        <h1>{{ $t("txt.headerOne") }}</h1>
        <h3>
          {{ $t("txt.headerThree") }}
          <span
            class="infoIcon"
            @click="showMainModal()"
          >
            i
          </span>
        </h3>
        <hr class="border-1 border-gray-500 mt-2">
        <div class="paraHolder">
          <p>{{ $t("txt.helpText") }}</p>
          <p>{{ $t("txt.helpTextExtra") }}</p>
        </div>
      </div>
      <div class="sideBtnBar">
        <div
          v-if="showPopulation"
        >
          <hr class="border-1 border-gray-500 mt-2">
          <div class="inline-flex uppercase text-sm">
            {{ $t("txt.population") }}
          </div>
          <div class="flex">
            <Button
              class="mr-1 text-xs"
              :class="isTotalPopClass"
              @click="showTotalPop()"
            >
              {{ $t("txt.totalPop") }}
            </Button>
            <Button
              class="mr-1 text-xs"
              :class="isTotalExtClass"
              @click="showTotalExt()"
            >
              {{ $t("txt.totalExt") }}
            </Button>
          </div>
        </div>
        <hr class="border-1 border-gray-500 mt-2">
        <div class="inline-flex uppercase text-sm">
          {{ $t("txt.religion") }}
        </div>
        <div
          v-for="(rel,relIndex) in opacityRamps"
          :id="`religion-${relIndex}`"
          :key="`religion-${relIndex}`"
          class="flex btn-bar mt-2"
        >
          <Button
            v-tooltip.top="$t(`txt.openUrltext`)"
            :class="relClass(relIndex)"
            :style="borderColorRight(relIndex)"
            @click="openWindowUrl(relIndex)"
          />
          <Button
            v-tooltip.top="$t(`txt.openUrltext`)"
            class="mr-1 text-xs w-8"
            :style="borderColorLeft(relIndex)"
            @click="openWindowUrl(relIndex)"
          >
            {{ $t(`txt.${relIndex}`) }} {{ hasOpenUrl(relIndex) }}
          </Button>
          <Button
            v-tooltip.top="$t(`txt.${relIndex}TooltipAbs`)"
            class="mr-1 perc-btn text-xs"
            :class="isTotalRelClass(relIndex)"
            @click="showTotalRel(relIndex)"
          >
            ABS
          </Button>
          <Button
            v-tooltip.top="$t(`txt.${relIndex}TooltipPerc`)"
            class="mr-1 perc-btn text-xs"
            :class="isTotalRelPercClass(relIndex)"
            @click="showTotalRelPerc(relIndex)"
          >
            %
          </Button>
          <Button
            v-if="rel.centers"
            v-tooltip.top="$t(`txt.centersMuni`)"
            class="mr-1 text-xs flex-3"
            :class="isCenterRelClass(relIndex)"
            :style="borderColorLeft(relIndex)"
            @click="showCenterRel(relIndex)"
          >
            {{ $t(`txt.${relIndex}Center`) }}
          </Button>
        </div>
      </div>
    </div>
    <div class="mapArea">
      <svg
        :class="mapClass()"
      />
      <Cuad
        :datum="findCurrentData()"
        :colors="colorScheme()"
        :territory="territory"
        :shown="isCuadShown"
      />
      <div class="mapFoot">
        <div class="muniName">
          {{ muniName }}
        </div>
        <div class="logoHolder">
          <div class="origami" />
          <div class="euskojaularitza" />
          <div class="ikuspegi" />
        </div>
      </div>
      <Ramp
        :ramp="getTheRamp()"
        :bg="muniColor"
        :enabled="rampColorEnable"
        :labeled="rampLabelEnable"
        :locked="rampLabelLock"
        :idx="activeRampIndex"
        :magnitude="rampMagnitude"
        :perc="isPerc"
      />
    </div>
    <!--
    <div class="btnBar">
      <Button
        class="mr-2"
        @click="openSuccessAlert"
      >
        Simple
      </Button>
      <Button
        class="mr-2"
        @click="openDangerAlert"
      >
        Alerta
      </Button>
      <Button
        class="mr-2"
        @click="openClosableInside"
      >
        Cerrar
      </Button>
      <Button
        v-tooltip.top="'No se cerrará clickando fuera'"
        @click="openSignIn"
      >
        Login
      </Button>
    </div>
    -->
    <ModalRoot />
  </div>
</template>

<script>

// import wrap from 'classcat'
// import * as _ from 'lodash'

import { ModalBus } from '../eventBus'

import ModalRoot from '../components/ModalRoot'
import Button from '../components/common/Button'
import Ramp from '../components/common/Ramp'
import Cuad from '../components/common/Cuad'

import commonMessages from '../locales/common'

import Alert from '../components/examples/Alert'
import ClosableInside from '../components/examples/ClosableInside'
import SignInForm from '../components/examples/SignInForm'

import * as d3 from 'd3'
import * as topojson from 'topojson-client'
import * as d3Composite from 'd3-composite-projections'

/* Events */

export default {
  name: 'Mapa',
  i18n: {
    messages: {},
    sharedMessages: commonMessages,
  },
  components: {
    Button,
    Ramp,
    Cuad,
    ModalRoot,
  },
  props: {
    msg: {
      type: String,
      default: 'MRE-1unes V.1.0.0',
    },
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      lang: 'es',
      scaleInit: 1,
      scaleEnd: 32,
      radius: d3.scaleSqrt().domain([0, 3e5]).range([0, 75]),
      projection: undefined,
      backRect: undefined,
      svg: undefined,
      g: undefined,
      path: undefined,
      active: undefined,
      municipalities: undefined,
      mapData: undefined,
      zoom: undefined,
      isZoomedClick: false,
      code: undefined,
      data: d3.map(),
      currentCode: undefined,
      hoverCode: undefined,
      opacityRampsGlobal: {
        ini: {
          mainColor: '#536780',
          magnitude: '',
          domain: [],
          range: [1],
          symbol: [],
          unit: [],
          color: [],
          code: [],
        },
        pop: {
          mainColor: '#536780',
          magnitude: 'magHab',
          domain: [100, 500, 1000, 5000, 25000, 100000, 400000],
          range: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8],
          symbol: ['<', '<', '<', '<', '<', '<', '<'],
          unit: ['', '', '', '', '', '', ''],
          color: ['#536780', '#536780', '#536780', '#536780', '#536780', '#536780', '#536780'],
        },
        perc: {
          mainColor: '#536780',
          magnitude: 'magHabPerc',
          domain: [1, 2, 3, 5, 10, 15, 20],
          range: [0.05, 0.1, 0.2, 0.3, 0.5, 0.75, 0.94],
          symbol: ['<', '<', '<', '<', '<', '<', '<'],
          unit: ['%', '%', '%', '%', '%', '%', '%'],
          color: ['#536780', '#536780', '#536780', '#536780', '#536780', '#536780', '#536780'],
        },
      },
      opacityRamps: {
        cat: {
          mainColor: '#943578',
          magnitude: 'mag_cat',
          domain: [100, 500, 1000, 2000, 5000, 100000, 250000],
          range: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8],
          domainPerc: [1, 2, 5, 10, 25, 50, 70],
          rangePerc: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8],
          symbol: ['<', '<', '<', '<', '<', '<', '<'],
          unit: ['', '', '', '', '', '', ''],
          unitPerc: ['%', '%', '%', '%', '%', '%', '%'],
          color: ['#943578', '#943578', '#943578', '#943578', '#943578', '#943578', '#943578'],
          centers: true,
          url: 'https://www.observatorioreligion.es/directorio-lugares-culto/',
        },
        mus: {
          mainColor: '#63A84D',
          magnitude: 'mag_mus',
          domain: [10, 100, 500, 1000, 5000, 10000, 20000],
          range: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8],
          domainPerc: [1, 2, 5, 10, 25, 50, 70],
          rangePerc: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8],
          symbol: ['<', '<', '<', '<', '<', '<', '<'],
          unit: ['', '', '', '', '', '', ''],
          unitPerc: ['%', '%', '%', '%', '%', '%', '%'],
          color: ['#63A84D', '#63A84D', '#63A84D', '#63A84D', '#63A84D', '#63A84D', '#63A84D'],
          centers: true,
          url: 'https://www.observatorioreligion.es/directorio-lugares-culto/',
        },
        pro: {
          mainColor: '#25A2D5',
          magnitude: 'mag_pro',
          domain: [10, 50, 100, 500, 1000, 2000, 5000],
          range: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8],
          domainPerc: [1, 2, 5, 10, 25, 50, 70],
          rangePerc: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8],
          symbol: ['<', '<', '<', '<', '<', '<', '<'],
          unit: ['', '', '', '', '', '', ''],
          unitPerc: ['%', '%', '%', '%', '%', '%', '%'],
          color: ['#25A2D5', '#25A2D5', '#25A2D5', '#25A2D5', '#25A2D5', '#25A2D5', '#25A2D5'],
          centers: true,
          url: 'https://www.observatorioreligion.es/directorio-lugares-culto/',
        },
        ort: {
          mainColor: '#FE8106',
          magnitude: 'mag_ort',
          domain: [10, 50, 100, 500, 1000, 2000, 5000],
          range: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8],
          domainPerc: [1, 2, 5, 10, 25, 50, 70],
          rangePerc: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8],
          symbol: ['<', '<', '<', '<', '<', '<', '<'],
          unit: ['', '', '', '', '', '', ''],
          unitPerc: ['%', '%', '%', '%', '%', '%', '%'],
          color: ['#FE8106', '#FE8106', '#FE8106', '#FE8106', '#FE8106', '#FE8106', '#FE8106'],
          centers: true,
          url: 'https://www.observatorioreligion.es/directorio-lugares-culto/',
        },
        jud: {
          mainColor: '#536780',
          magnitude: 'mag_mus',
          domain: [5, 10, 25, 50, 100, 250, 500],
          range: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8],
          domainPerc: [1, 2, 5, 10, 25, 50, 70],
          rangePerc: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8],
          symbol: ['<', '<', '<', '<', '<', '<', '<'],
          unit: ['', '', '', '', '', '', ''],
          unitPerc: ['%', '%', '%', '%', '%', '%', '%'],
          color: ['#536780', '#536780', '#536780', '#536780', '#536780', '#536780', '#536780'],
          centers: true,
          url: 'https://www.observatorioreligion.es/directorio-lugares-culto/',
        },
        hin: {
          mainColor: '#536780',
          magnitude: 'mag_hin',
          domain: [5, 10, 25, 50, 100, 250, 500],
          range: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8],
          domainPerc: [1, 2, 5, 10, 25, 50, 70],
          rangePerc: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8],
          symbol: ['<', '<', '<', '<', '<', '<', '<'],
          unit: ['', '', '', '', '', '', ''],
          unitPerc: ['%', '%', '%', '%', '%', '%', '%'],
          color: ['#536780', '#536780', '#536780', '#536780', '#536780', '#536780', '#536780'],
          centers: true,
          url: 'https://www.observatorioreligion.es/directorio-lugares-culto/',
        },
        bud: {
          mainColor: '#536780',
          magnitude: 'mag_bud',
          domain: [5, 10, 25, 50, 100, 250, 500],
          range: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8],
          domainPerc: [1, 2, 5, 10, 25, 50, 70],
          rangePerc: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8],
          symbol: ['<', '<', '<', '<', '<', '<', '<'],
          unit: ['', '', '', '', '', '', ''],
          unitPerc: ['%', '%', '%', '%', '%', '%', '%'],
          color: ['#536780', '#536780', '#536780', '#536780', '#536780', '#536780', '#536780'],
          centers: true,
          url: 'https://www.observatorioreligion.es/directorio-lugares-culto/',
        },
        otr: {
          mainColor: '#536780',
          magnitude: 'mag_otr',
          domain: [5, 10, 25, 50, 100, 250, 500],
          range: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8],
          domainPerc: [1, 2, 5, 10, 25, 50, 70],
          rangePerc: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8],
          symbol: ['<', '<', '<', '<', '<', '<', '<'],
          unit: ['', '', '', '', '', '', ''],
          unitPerc: ['%', '%', '%', '%', '%', '%', '%'],
          color: ['#536780', '#536780', '#536780', '#536780', '#536780', '#536780', '#536780'],
          centers: true,
          url: undefined,
        },
        no: {
          mainColor: '#212121',
          magnitude: 'mag_no',
          domain: [100, 500, 1000, 5000, 20000, 50000, 100000],
          range: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8],
          domainPerc: [1, 2, 5, 10, 25, 50, 70],
          rangePerc: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8],
          symbol: ['<', '<', '<', '<', '<', '<', '<'],
          unit: ['', '', '', '', '', '', ''],
          unitPerc: ['%', '%', '%', '%', '%', '%', '%'],
          color: ['#212121', '#212121', '#212121', '#212121', '#212121', '#212121', '#212121'],
          centers: false,
          url: undefined,
        },
      },
      colorScale: d3.scaleThreshold().domain([100, 500, 1000, 2000, 10000, 100000, 500000]).range(d3.schemeReds[7]),
      alphaScale: d3.scaleLinear().domain([100, 500, 1000, 2000, 10000, 100000, 500000]).range(['rgba(0,0,0,0)', 'rgba(0,0,0,0.5)']),
      sequeScale: d3.scaleSequential(d3.interpolateReds).domain([100, 500, 1000, 2000, 10000, 100000, 500000]),
      rampColorEnable: true,
      rampLabelEnable: false,
      rampLabelLock: false,
      muniColor: undefined,
      muniColorInit: '#536780',
      initZoom: {
        k: 16,
        x: -8478.626235698968,
        y: -250.9209158313189,
      },
      zoomIdentity: undefined,
      isEnabledSomething: false,
      currentRow: undefined,
      isHiddeMainModal: false,
      isTotalPop: false,
      isTotalExt: false,
      isTotalRel: {
        cat: false,
        pro: false,
        ort: false,
        cri: false,
        mus: false,
        jud: false,
        hin: false,
        bud: false,
        ani: false,
        otr: false,
        no: false,
      },
      isTotalRelPerc: {
        cat: false,
        pro: false,
        ort: false,
        cri: false,
        mus: false,
        jud: false,
        hin: false,
        bud: false,
        ani: false,
        otr: false,
        no: false,
      },
      isTotalCat: false,
      showCenters: false,
      isCenterRel: {
        cat: false,
        pro: false,
        ort: false,
        cri: false,
        mus: false,
        jud: false,
        hin: false,
        bud: false,
        ani: false,
        otr: false,
        no: false,
      },
      showPopulation: false,
      isCuadShown: false,
      territory: '',
      isPerc: false,
    }
  },
  computed: {
    loc () {
      const upper = this.$i18n.locale.toUpperCase()
      return `${this.$i18n.locale}-${upper}`
    },
    viewbox () {
      return `0,0,${this.width},${this.height}`
    },
    muniName () {
      let res
      if (this.hoverCode > 1) {
        res = this.findMuniNameByCode(this.hoverCode)
      } else {
        res = ''
      }
      return res
    },
    religion () {
      return this.religionText[this.lang]
    },
    totalPop () {
      return this.totalPopText[this.lang]
    },
    totalExt () {
      return this.totalExtText[this.lang]
    },
    cat () {
      return this.catText[this.lang]
    },
    c_cat () {
      return this.centerCatText[this.lang]
    },
    mainModalClass () {
      return (this.isHiddeMainModal) ? 'hidden' : ''
    },
    isTotalPopClass () {
      return (this.isTotalPop) ? 'active' : ''
    },
    isTotalExtClass () {
      return (this.isTotalExt) ? 'active' : ''
    },
    isTotalCatClass () {
      return (this.isTotalRel.cat) ? 'active' : ''
    },
    isTotalCatPercClass () {
      return (this.isTotalRelPerc.cat) ? 'active' : ''
    },
    isTotalProClass () {
      return (this.isTotalRel.pro) ? 'active' : ''
    },
    isTotalOrtClass () {
      return (this.isTotalRel.ort) ? 'active' : ''
    },
    isTotalMusClass () {
      return (this.isTotalRel.mus) ? 'active' : ''
    },
    isTotalJudClass () {
      return (this.isTotalRel.jud) ? 'active' : ''
    },
    isTotalHinClass () {
      return (this.isTotalRel.hid) ? 'active' : ''
    },
    isTotalBudClass () {
      return (this.isTotalRel.bud) ? 'active' : ''
    },
    isTotalOtrClass () {
      return (this.isTotalRel.otr) ? 'active' : ''
    },
    isTotalNoClass () {
      return (this.isTotalRel.no) ? 'active' : ''
    },
    rampMagnitude () {
      // let res = this.magInitial[this.lang]
      let res = this.$t('txt.magInitial')
      if (this.isTotalPop) {
        // res = this.magHab[this.lang]
        res = this.$t('txt.magHab')
      }
      if (this.isTotalExt) {
        // res = this.magHabPerc[this.lang]
        res = this.$t('txt.magHab')
      }
      if (this.isTotalRel[this.currentRow]) {
        // res = this.magCat[this.lang]
        res = this.$t(`txt.mag_${this.currentRow}`)
      }
      if (this.isTotalRelPerc[this.currentRow]) {
        // res = this.magCat[this.lang]
        res = this.$t(`txt.mag_perc_${this.currentRow}`)
      }
      return res
    },
    opacityScalePop () {
      return d3.scaleThreshold().domain(this.opacityRampsGlobal.pop.domain).range(this.opacityRampsGlobal.pop.range)
    },
    opacityScaleExt () {
      return d3.scaleThreshold().domain(this.opacityRampsGlobal.perc.domain).range(this.opacityRampsGlobal.perc.range)
    },
    opacityScaleCat () {
      return d3.scaleThreshold().domain(this.opacityRamps.cat.domain).range(this.opacityRamps.cat.range)
    },
    opacityScaleRel () {
      return d3.scaleThreshold().domain(this.opacityRamps[this.currentRow].domain).range(this.opacityRamps[this.currentRow].range)
    },
    opacityScaleRelPerc () {
      return d3.scaleThreshold().domain(this.opacityRamps[this.currentRow].domainPerc).range(this.opacityRamps[this.currentRow].rangePerc)
    },
    activeRampIndex () {
      let res = -1
      if (this.isTotalPop) {
        // res = this.findMuniRampPopIndexByCode(this.currentCode)
        res = this.findMuniRampRowIndexByCode(this.currentCode, 'pop', false)
      }
      if (this.isTotalExt) {
        // res = this.findMuniRampExtIndexByCode(this.currentCode)
        res = this.findMuniRampRowIndexByCode(this.currentCode, 'perc', false)
      }
      if (this.isTotalRel[this.currentRow]) {
        res = this.findMuniRampRowIndexByCode(this.currentCode, this.currentRow, false)
      }
      if (this.isTotalRelPerc[this.currentRow]) {
        res = this.findMuniRampRowIndexByCode(this.currentCode, this.currentRow, true)
      }
      return res
    },
    topologyHex () {
      return this.hexTopology(this.radius, this.width, this.height)
    },
  },
  beforeCreate () {
    console.log('beforeCreate', d3)
  },
  created () {
    console.log('created')
  },
  beforeMount () {
    console.log('beforeMount', d3)
  },
  mounted () {
    // Moved to computed
    this.svg = d3.select('svg').attr('viewBox', [0, 0, this.width, this.height])
    // this.svg = d3.select('svg')
    this.backRect = this.svg.append('rect')
      .attr('class', 'back-rect')
      .attr('width', this.width)
      .attr('height', this.height)
      // .attr('fill', 'none')
      .on('click', this.resetZoom)
      .on('mouseover', () => {
        if (this.isEnabledSomething && !this.rampLabelLock) {
          // Disable Color change to gray on :hover
          // this.muniColor = this.muniColorInit
          this.currentCode = -1
        }
        this.hoverCode = -1
      })

    this.g = this.svg.append('g')
    /*
    this.g.attr('transform', `translate(${this.initZoom.x},${this.initZoom.y}) scale(${this.initZoom.k})`)
    this.g.attr('stroke-width', 1 / this.initZoom.k)
    */
    this.zoomIdentity = d3.zoomIdentity.translate(this.initZoom.x, this.initZoom.y).scale(this.initZoom.k)

    this.active = d3.select(null)
    // AUTO ZOOM BAAD

    this.projection = d3Composite.geoConicConformalSpain()
    // .scale(1000)
    // .translate(-0.378599213362, -0.31424236951898)

    /* Manual ZOOM
    this.projection = d3Composite.geoConicConformalSpain()
      .scale(28000)
      .translate([-this.width / 2.8, this.height * 4.7])
    */

    this.path = d3.geoPath(this.projection)

    this.zoom = d3.zoom()
      .scaleExtent([this.scaleInit, this.scaleEnd])
      .on('zoom', this.zoomInitial)

    Promise.all([
      d3.dsv(',', './csv/MRE-Municipios-EUSKADI.csv', d => {
        return {
          code: d.code,
          name: d.name,
          ext: +d.ext,
          esp: +d.esp,
          pop: +d.pop,
          perc: +d.perc,
          lat: +d.lat,
          lan: +d.lan,
          cat: +d.cat,
          mus: +d.mus,
          pro: +d.pro,
          ort: +d.ort,
          jud: +d.jud,
          hin: +d.hin,
          bud: +d.bud,
          otr: +d.otr,
          no: +d.no,
          cat_esp: +d.cat_esp,
          mus_esp: +d.mus_esp,
          pro_esp: +d.pro_esp,
          ort_esp: +d.ort_esp,
          jud_esp: +d.jud_esp,
          hin_esp: +d.hin_esp,
          bud_esp: +d.bud_esp,
          otr_esp: +d.otr_esp,
          no_esp: +d.no_esp,
          c_cat: +d.c_cat,
          c_pro: +d.c_pro,
          c_ort: +d.c_ort,
          c_mus: +d.c_mus,
          c_jud: +d.c_jud,
          c_hin: +d.c_hin,
          c_bud: +d.c_bud,
          c_otr: +d.c_otr,
        }
      }),
      d3.json('./json/eus-municipalities.json'),
    ]).then(data => {
      this.loadMuniData(data[0])
      this.renderMapData(data[1])
    }).catch(err => console.warn(err))

    // Enable MOUSE ZOOM
    this.g.call(this.zoom.transform, this.zoomIdentity)
  },
  methods: {
    mapClass () {
      return 'mapa'
    },
    relClass (key) {
      return `mr-1 svg-rel svg-${key}`
    },
    borderColorRight (key) {
      return `border-right: 4px solid ${this.opacityRamps[key].mainColor}`
    },
    borderColorLeft (key) {
      return `border-left: 4px solid ${this.opacityRamps[key].mainColor}`
    },
    tooltipDesc (key) {
      return `Población total adscrita al catolicismo ${this.opacityRamps[key].mainColor}`
    },
    isTotalRelClass (key) {
      return (this.isTotalRel[key]) ? 'active' : ''
    },
    isTotalRelPercClass (key) {
      return (this.isTotalRelPerc[key]) ? 'active' : ''
    },
    loadMuniData (data) {
      this.municipalities = data
    },
    renderMapData (data) {
      // Municipalities OK
      this.mapData = data
      this.g.selectAll('path')
        .data(topojson.feature(data, data.objects.municipalities).features)
        .enter()
        .append('path')
        .attr('d', this.path)
        .attr('class', this.addColorToPath)
        .attr('fill', (d, i, n) => {
          return this.opacityRampsGlobal.ini.mainColor
        })
        .on('click', (d, i, n) => {
          this.zoomItClick(d, i, n)
        })
        .on('mouseover', (d, i, n) => {
          this.mouseoverPath(d, i, n)
        })
      // hover labels
      this.g.selectAll('label')
        .data(topojson.feature(data, data.objects.municipalities).features)
        .enter()
        .append('text')
        .attr('x', (d) => { return this.path.centroid(d)[0] })
        .attr('y', (d) => { return this.path.centroid(d)[1] })
        .text(this.drawMuniTextName)
        .attr('text-anchor', 'middle')
        .attr('class', 'label')
        .attr('id', (d) => { return `label_${d.id}` })
        // .style('fill', 'white')
        // .style('font-size', 0.5)
        // .attr('alignment-baseline', 'central')
    },
    colorScheme () {
      return {
        cat: this.opacityRamps.cat.mainColor,
        mus: this.opacityRamps.mus.mainColor,
        pro: this.opacityRamps.pro.mainColor,
        ort: this.opacityRamps.ort.mainColor,
        jud: this.opacityRamps.jud.mainColor,
        hin: this.opacityRamps.hin.mainColor,
        bud: this.opacityRamps.bud.mainColor,
        otr: this.opacityRamps.otr.mainColor,
        no: this.opacityRamps.no.mainColor,
      }
    },
    findCurrentData () {
      let findedMunicipality
      let findedMunicipalityData
      if (this.municipalities !== null) {
        if (this.currentCode !== undefined) {
          findedMunicipality = this.municipalities.find(x => x.code === this.currentCode)
        }
        if (findedMunicipality !== undefined) {
          findedMunicipalityData = findedMunicipality
        } else {
          findedMunicipalityData = {}
        }
      }
      return findedMunicipalityData
    },
    findMuniNameByCode (code) {
      let findedMunicipality
      let findedMunicipalityName = ' '
      if (this.municipalities !== null) {
        findedMunicipality = this.municipalities.find(x => x.code === code)
        if (findedMunicipality !== undefined) {
          findedMunicipalityName = findedMunicipality.name
        }
      }
      return `${findedMunicipalityName}`
    },
    findMuniRowByCode (code, row) {
      let findedMunicipality
      let findedMunicipalityItem = '---'
      if (this.municipalities !== null) {
        findedMunicipality = this.municipalities.find(x => x.code === code)
        if (findedMunicipality !== undefined) {
          findedMunicipalityItem = findedMunicipality[row]
        }
      }
      return findedMunicipalityItem
    },
    findMuniByCode (code) {
      let findedMunicipality
      let findedMunicipalityName = ' '
      if (this.municipalities !== null) {
        findedMunicipality = this.municipalities.find(x => x.code === code)
        if (findedMunicipality !== undefined) {
          findedMunicipalityName = findedMunicipality.name
        }
      }
      return `${code} - ${findedMunicipalityName}`
    },
    findMuniColorByCode (code) {
      const codeSub = code.substring(0, 2)
      const isCodeSub = (element) => element === codeSub
      const findIndex = this.opacityRampsGlobal.ini.code.findIndex(isCodeSub)
      return this.opacityRampsGlobal.ini.color[findIndex]
    },
    findRowIntByCode (row, code) {
      let findedMunicipality
      let findedMunicipalityItem = ''
      if (this.municipalities !== null) {
        findedMunicipality = this.municipalities.find(x => x.code === code)
        if (findedMunicipality !== undefined) {
          findedMunicipalityItem = findedMunicipality[row]
        }
      }
      return parseInt(findedMunicipalityItem)
    },
    findPopByCode (code) {
      let findedMunicipality
      let findedMunicipalityPop = ''
      if (this.municipalities !== null) {
        findedMunicipality = this.municipalities.find(x => x.code === code)
        if (findedMunicipality !== undefined) {
          findedMunicipalityPop = findedMunicipality.pop
        }
      }
      return parseInt(findedMunicipalityPop)
    },
    findExtByCode (code) {
      let findedMunicipality
      let findedMunicipalityExt = ''
      if (this.municipalities !== null) {
        findedMunicipality = this.municipalities.find(x => x.code === code)
        if (findedMunicipality !== undefined) {
          findedMunicipalityExt = findedMunicipality.perc
        }
      }
      return findedMunicipalityExt
    },
    findMuniRampPopIndexByCode (code) {
      const val = this.findRowIntByCode('pop', code)
      const codePlus = (element) => element >= val
      const findIndex = this.opacityRampsGlobal.ini.domain.findIndex(codePlus)
      return findIndex
    },
    findMuniRampExtIndexByCode (code) {
      const val = this.findRowIntByCode('perc', code)
      const codePlus = (element) => element >= val
      const findIndex = this.opacityRampsGlobal.perc.domain.findIndex(codePlus)
      return findIndex
    },
    findMuniRampRowIndexByCode (code, row, isPerc) {
      let val
      let codePlus
      let findIndex
      if (!isPerc) {
        val = this.findRowIntByCode(row, code)
        codePlus = (element) => element >= val
        findIndex = this.opacityRamps[row].domain.findIndex(codePlus)
      } else {
        const totalExt = this.findRowIntByCode('ext', code)
        val = (this.findRowIntByCode(row, code) - this.findRowIntByCode(`${row}_esp`, code)) / totalExt * 100
        codePlus = (element) => element >= val
        findIndex = this.opacityRamps[row].domainPerc.findIndex(codePlus)
      }
      return findIndex
    },
    addColorToPath (d, i, n) {
      const code = d.id.substring(0, 2)
      let muniClass = ''
      switch (code) {
        case '01':
          muniClass = 'Araba'
          break
        case '20':
          muniClass = 'Gipuzkoa'
          break
        case '48':
          muniClass = 'Bizkaia'
          break
        default:
          muniClass = 'Neutral'
          break
      }
      return `municipalities ${muniClass}`
    },
    findTerritory (code) {
      const subsCode = code.substring(0, 2)
      let territory = ''
      switch (subsCode) {
        case '01':
          territory = 'Araba'
          break
        case '20':
          territory = 'Gipuzkoa'
          break
        case '48':
          territory = 'Bizkaia'
          break
        default:
          territory = ''
          break
      }
      return territory
    },
    drawMuniTextName (d, i, n) {
      const code = d.id
      return this.findMuniNameByCode(code)
    },
    drawMuniRowVal (d, i, n, row) {
      const code = d.id
      return this.findMuniRowByCode(code, row)
    },
    drawMuniRowValClass (d, i, n, row, initClass) {
      const code = d.id
      const res = this.findMuniRowByCode(code, row)
      return (res === 0) ? `${initClass} hidden` : `${initClass}`
    },
    zoomItClick (d, i, n) {
      const code = d.id

      this.currentCode = code

      this.territory = this.findTerritory(code)

      if (this.active === n[i]) {
        return this.resetZoom()
      } else {
        this.active = n[i]
      }

      this.rampLabelLock = true
      this.rampColorEnable = true
      this.rampLabelEnable = true

      d3.selectAll('.municipalities').classed('active', false)
      d3.select(n[i]).classed('active', true)

      d3.selectAll('.label').classed('active', false)
      d3.select(`#label_${d.id}`).classed('active', true)

      if (this.showCenters) {
        d3.selectAll('.center-circle').classed('zoomed', false)
        d3.selectAll('.center-circle').classed('active', false)
        d3.selectAll('.center-number').classed('zoomed', false)
        d3.selectAll('.center-number').classed('active', false)
        this.showCenterPin(this.currentCode, this.currentRow)
      }

      const [[x0, y0], [x1, y1]] = this.path.bounds(d)
      d3.event.stopPropagation()
      this.g.transition().duration(750).call(
        this.zoom.transform,
        d3.zoomIdentity
          .translate(this.width / 2, this.height / 3)
          .scale(Math.min(this.scaleEnd, 0.94 / Math.max((x1 - x0) / this.width, (y1 - y0) / this.height)))
          .translate(-(x0 + x1) / 2, -(y0 + y1) / 2),
        d3.mouse(this.svg.node()),
      )
      this.isZoomedClick = true
      this.isCuadShown = true
    },
    mouseoverPath (d, i, n) {
      const code = d.id
      this.hoverCode = code
      d3.select(n[i]).attr({
        fill: 'orange',
        r: this.radius * 2,
      })
      if (this.isEnabledSomething) {
        this.muniColor = this.findMuniColorByCode(code)
      }
      if (!this.rampLabelLock) {
        this.currentCode = code
      }
    },
    resetZoom () {
      d3.selectAll('.municipalities').classed('active', false)
      d3.selectAll('.label').classed('active', false)
      if (this.showCenters) {
        d3.selectAll('.center-circle').classed('active', true)
        d3.selectAll('.center-number').classed('active', true)
        d3.selectAll('.center-circle').classed('zoomed', false)
        d3.selectAll('.center-number').classed('zoomed', false)
      } else {
        d3.selectAll('.center-circle').classed('active', false)
        d3.selectAll('.center-number').classed('active', false)
        d3.selectAll('.center-circle').classed('zoomed', false)
        d3.selectAll('.center-number').classed('zoomed', false)
      }
      this.currentCode = -1
      this.rampLabelLock = false
      this.rampColorEnable = true
      /*
      if (this.isEnabledSomething) {
        this.rampColorEnable = true
      } else {
        this.rampColorEnable = false
      }
      */
      this.active = d3.select(null)
      this.g.transition().duration(750).call(
        this.zoom.transform,
        this.zoomIdentity,
        d3.zoomTransform(this.svg.node()).invert([this.width / 2, this.height / 2]),
      )
      this.isZoomedClick = false
      this.isCuadShown = false
    },
    zoomInitial () {
      const { transform } = d3.event
      // console.log('transform', transform)
      this.g.attr('transform', transform)
      this.g.attr('stroke-width', 1 / transform.k)
    },
    drawCenters (row) {
      // data centers
      this.g.selectAll('.center-number-holder').remove()

      const elemHolder = this.g.selectAll('center-number-holder')
        .data(topojson.feature(this.mapData, this.mapData.objects.municipalities).features)
        .enter()
        .append('g')
        .attr('class', 'center-number-holder')
        .attr('x', (d) => { return this.path.centroid(d)[0] - 0.6 })
        .attr('y', (d) => { return this.path.centroid(d)[1] + 0.275 })
        .attr('class', (d, i, n) => {
          return this.drawMuniRowValClass(d, i, n, `c_${row}`, 'center-number-holder')
        })

      /* Create the circle for each block */
      elemHolder
        .append('rect')
        .attr('rx', 1)
        .attr('ry', 1)
        .attr('width', 1.2)
        .attr('height', 1.2)
        .attr('x', (d) => { return this.path.centroid(d)[0] - 0.6 })
        .attr('y', (d) => { return this.path.centroid(d)[1] + 0.275 })
        .attr('id', (d) => { return `center_circle_${row}_${d.id}` })
        .attr('class', 'center-circle')

      elemHolder
        .append('text')
        .attr('x', (d) => { return this.path.centroid(d)[0] })
        .attr('y', (d) => { return this.path.centroid(d)[1] + 1.15 })
        .text((d, i, n) => {
          return this.drawMuniRowVal(d, i, n, `c_${row}`)
        })
        .attr('fill', '#FFFFFF')
        .attr('text-anchor', 'middle')
        .attr('id', (d) => { return `center_${row}_${d.id}` })
        .attr('class', 'center-number')
    },
    getTheRamp () {
      let res
      switch (this.isEnabledSomething) {
        case false:
          res = this.opacityRampsGlobal.ini
          break
        case true:
          if (this.isTotalPop) {
            res = this.opacityRampsGlobal.pop
            break
          }
          if (this.isTotalExt) {
            res = this.opacityRampsGlobal.perc
            break
          }
          if (this.isTotalRel[this.currentRow]) {
            res = this.opacityRamps[this.currentRow]
            break
          }
          if (this.isTotalRelPerc[this.currentRow]) {
            res = this.opacityRamps[this.currentRow]
            break
          }
          // break
      }
      return res
    },
    getTheCuad () {
      const res = {}
      return res
    },
    resetStatusBtn () {
      this.isEnabledSomething = false
      // this.rampColorEnable = !this.rampLabelLock
      this.rampLabelEnable = false
      this.isTotalPop = false
      this.isTotalExt = false
      // this.isTotalCat = false
      this.isTotalRel[this.currentRow] = false
      this.isTotalRelPerc[this.currentRow] = false
      // this.isCenterRel[this.currentRow] = false
      for (var [key] of Object.entries(this.isTotalRel)) {
        this.isTotalRel[key] = false
      }
      for (var [keyPerc] of Object.entries(this.isTotalRelPerc)) {
        this.isTotalRelPerc[keyPerc] = false
      }
    },
    resetCentersBtn () {
      for (var [key] of Object.entries(this.isCenterRel)) {
        this.isCenterRel[key] = false
      }
    },
    resetPathOpacity () {
      this.g.selectAll('path')
        .attr('fill-opacity', (d, i, n) => {
          return 1
        })
    },
    showTotalPop () {
      if (!this.isTotalPop) {
        this.resetStatusBtn()
        this.isTotalPop = true
        this.currentRow = 'pop'
        this.isEnabledSomething = true
        // this.rampColorEnable = !this.rampLabelLock
        this.rampLabelEnable = true
        this.g.selectAll('path')
          .attr('fill', this.opacityRampsGlobal.ini.mainColor)
          .attr('fill-opacity', (d, i, n) => {
            return this.opacityScalePop(this.findRowIntByCode('pop', d.id))
          })
      } else {
        // this.rampColorEnable = false
        this.g.selectAll('path')
          .attr('fill', this.opacityRampsGlobal.ini.mainColor)
        this.resetStatusBtn()
        this.resetPathOpacity()
      }
    },
    showTotalExt () {
      if (!this.isTotalExt) {
        this.resetStatusBtn()
        this.isTotalExt = true
        this.currentRow = 'perc'
        this.isEnabledSomething = true
        // this.rampColorEnable = !this.rampLabelLock
        this.rampLabelEnable = true
        this.g.selectAll('path')
          .attr('fill', this.opacityRampsGlobal.perc.mainColor)
          .attr('fill-opacity', (d, i, n) => {
            return this.opacityScaleExt(this.findRowIntByCode('perc', d.id))
          })
      } else {
        // this.rampColorEnable = false
        this.g.selectAll('path')
          .attr('fill', this.opacityRampsGlobal.perc.mainColor)
        this.resetStatusBtn()
        this.resetPathOpacity()
      }
    },
    showTotalRel (row) {
      if (!this.isTotalRel[row]) {
        this.resetStatusBtn()
        this.isTotalRel[row] = true
        this.currentRow = row
        this.isEnabledSomething = true
        this.isPerc = false
        // this.rampColorEnable = !this.rampLabelLock
        this.rampLabelEnable = true
        this.g.selectAll('path')
          .attr('fill', (d, i, n) => {
            return this.opacityRamps[row].mainColor
          })
          .attr('fill-opacity', (d, i, n) => {
            return this.opacityScaleRel(this.findRowIntByCode(row, d.id))
          })
      } else {
        // this.rampColorEnable = false
        this.resetStatusBtn()
        this.resetPathOpacity()
        this.g.selectAll('path')
          .attr('fill', (d, i, n) => {
            return this.opacityRampsGlobal.ini.mainColor
          })
      }
    },
    openWindowUrl (row) {
      const url = this.opacityRamps[row].url
      if (url !== undefined) {
        window.open(url)
      }
    },
    hasOpenUrl (row) {
      const url = this.opacityRamps[row].url
      if (url !== undefined) {
        return '✱'
      }
    },
    showTotalRelPerc (row) {
      if (!this.isTotalRelPerc[row]) {
        this.resetStatusBtn()
        this.isTotalRelPerc[row] = true
        this.currentRow = row
        this.isEnabledSomething = true
        this.isPerc = true
        // this.rampColorEnable = !this.rampLabelLock
        this.rampLabelEnable = true
        this.g.selectAll('path')
          .attr('fill', (d, i, n) => {
            return this.opacityRamps[row].mainColor
          })
          .attr('fill-opacity', (d, i, n) => {
            const totalExt = this.findRowIntByCode('ext', d.id)
            const diff = this.findRowIntByCode(row, d.id) - this.findRowIntByCode(`${row}_esp`, d.id)
            let res
            if (totalExt !== 0) {
              res = this.opacityScaleRelPerc(diff / totalExt * 100)
            } else {
              res = 0
            }
            return res
          })
      } else {
        // this.rampColorEnable = false
        this.resetStatusBtn()
        this.resetPathOpacity()
        this.g.selectAll('path')
          .attr('fill', (d, i, n) => {
            return this.opacityRampsGlobal.ini.mainColor
          })
      }
    },
    showCenterPin (code, row) {
      d3.select(`#center_${row}_${code}`).classed('active', true)
      d3.select(`#center_${row}_${code}`).classed('zoomed', true)
      d3.select(`#center_circle_${row}_${code}`).classed('active', true)
      d3.select(`#center_circle_${row}_${code}`).classed('zoomed', true)
    },
    hideCenterPin (code, row) {
      d3.select(`#center_${row}_${code}`).classed('active', false)
      d3.select(`#center_${row}_${code}`).classed('zoomed', false)
      d3.select(`#center_circle_${row}_${code}`).classed('active', false)
      d3.select(`#center_circle_${row}_${code}`).classed('zoomed', false)
    },
    showCenterRel (row) {
      if (!this.isCenterRel[row]) {
        this.resetCentersBtn()
        this.isCenterRel[row] = true
        this.showCenters = true
        this.currentRow = row
        // this.isEnabledSomething = true
        // this.rampColorEnable = !this.rampLabelLock
        // this.rampLabelEnable = true
        this.drawCenters(this.currentRow)
        d3.selectAll('.center-circle').classed('zoomed', false)
        d3.selectAll('.center-circle').classed('active', false)
        // d3.selectAll('.center-circle').classed('hidden', false)
        d3.selectAll('.center-number').classed('active', false)
        d3.selectAll('.center-number').classed('hidden', false)
        // d3.selectAll('.center-number').classed('zoomed', false)
        if (this.isZoomedClick) {
          this.showCenterPin(this.currentCode, this.currentRow)
        } else {
          d3.selectAll('.center-circle').classed('active', true)
          d3.selectAll('.center-number').classed('active', true)
        }
      } else {
        this.resetCentersBtn()
        this.showCenters = false
        // this.resetStatusBtn()
        // this.resetPathOpacity()
        if (this.isZoomedClick) {
          this.hideCenterPin(this.currentCode, this.currentRow)
        } else {
          d3.selectAll('.center-circle').classed('active', false)
          d3.selectAll('.center-number').classed('active', false)
        }
      }
    },
    showMainModal () {
      this.isHiddeMainModal = false
    },
    hideMainModal () {
      this.isHiddeMainModal = true
    },
    openSuccessAlert () {
      ModalBus.$emit('open', {
        component: Alert,
        props: { text: 'Sistema de Modales!', type: 'success' },
      })
    },
    openDangerAlert () {
      const props = {
        type: 'error',
        text: 'Esto es un error! omg!',
      }
      ModalBus.$emit('open', {
        component: Alert,
        title: 'Ocurrió un error',
        props,
      })
    },
    openClosableInside () {
      ModalBus.$emit('open', {
        component: ClosableInside,
        title: 'Cerrar modal desde el componente',
      })
    },
    openSignIn () {
      ModalBus.$emit('open', {
        component: SignInForm,
        title: 'New user',
        closeOnClick: false,
      })
    },
    isCenterRelClass (row) {
      return (this.isCenterRel[row]) ? 'active' : ''
    },
    hexDrawHund () {
      return 'M 440 10 L 873.013 260 L 873.013 760 L 440 1010 L 6.9873 760 L 6.9873 260 Z'
    },
    hexTopology (radius, width, height) {
      const dx = radius * 2 * Math.sin(Math.PI / 3)
      const dy = radius * 1.5
      const n = Math.ceil(width / dx) + 1
      const geometries = []
      const arcs = []
      const m = Math.ceil((height + radius) / dy) + 1

      for (var j = -1; j <= m; ++j) {
        for (var i = -1; i <= n; ++i) {
          var y = j * 2
          var x = (i + (j & 1) / 2) * 2
          arcs.push([[x, y - 1], [1, 1]], [[x + 1, y], [0, 1]], [[x + 1, y + 1], [-1, 1]])
        }
      }

      for (var jj = 0, q = 3; jj < m; ++jj, q += 6) {
        for (var ii = 0; ii < n; ++ii, q += 3) {
          geometries.push({
            type: 'Polygon',
            arcs: [[q, q + 1, q + 2, ~(q + (n + 2 - (jj & 1)) * 3), ~(q - 2), ~(q - (n + 2 + (jj & 1)) * 3 + 2)]],
            fill: Math.random() > ii / n * 2,
          })
        }
      }

      return {
        transform: { translate: [0, 0], scale: [1, 1] },
        objects: { hexagons: { type: 'GeometryCollection', geometries: geometries } },
        arcs: arcs,
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

@import '@/mixin.scss';

  .mapaSection {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media (min-width: 640px) {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin: 0;
      padding: 0;
      height: 100%;
    }
  }

  .iniWindow {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    //bottom: 0;
    overflow-y: auto;
    z-index: 1;
    display: flex;
    flex-direction: column;
    background-color: #E2E8F0;
    margin: .5rem;
    padding: .5rem;
    width: calc(100% - 1rem);
    height: calc(100% - 1rem);
    @media (min-width: 640px) {
      flex-direction: row;
      padding: 2rem;
    }
    .mapIconCol {
      width: 2rem;
      padding: 1rem;
      margin: .5rem;
      background-image: url(/img/euskadi.png);
      background-size: contain;
      background-repeat: no-repeat;
      @media (min-width: 640px) {
        margin: .5rem;
        width: 8rem;
      }
    }
    .textCol {
      display: flex;
      flex-direction: column;
      flex: 1;
      justify-content: space-between;
      .headerCol {
        display: flex;
        flex-direction: row;
        @media (min-width: 768px) {
          width: 34rem;
        }
        h1 {
          font-size: 3rem;
          font-weight: 400;
          line-height: 1.2;
        }
      }
      .bodyCol {
        display: flex;
        flex-direction: column;
        @media (min-width: 768px) {
          flex-direction: row;
        }
        padding-top: 1rem;
        .descCol {
          flex: .8;
          max-height: 30rem;
          overflow: auto;
          @media (min-width: 640px) {
            margin-right: 1rem;
            padding-right: 2rem;
          }
          h3 {
            font-size: 1.3rem;
            font-weight: 700;
            line-height: 1.2;
            margin-bottom: 1rem;
            @media (min-width: 1919px) {
              font-size: 1.6rem;
            }
          }
          p {
            font-size: 1rem;
            line-height: 1.2;
            @media (min-width: 1919px) {
              font-size: 1.3rem;
            }
          }
        }
        .tableCol {
          flex: 1.6;
          margin-top: 2.5rem;
          @media (min-width: 480px) {
            margin-top: 0;
          }
          @media (min-width: 1919px) {
            flex: 1.3;
          }
        }
      }
      .logoCol {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        .origami {
          width: 5rem;
          height: 5rem;
          background-image: url(/img/origami-logo.png);
          background-size: contain;
          background-repeat: no-repeat;
          background-position: 50% 50%;
          margin-top: .5rem;
          margin-right: 2rem;
          @media (min-width: 1919px) {
            width: 7.5rem;
            height: 7.5rem;
          }
        }
        .euskojaularitza {
          width: 18rem;
          height: 5rem;
          background-image: url(/img/hori_gv_bilingue.png);
          background-size: contain;
          background-repeat: no-repeat;
          background-position: 50% 50%;
          margin-top: .5rem;
          margin-right: 2rem;
          @media (min-width: 1919px) {
            width: 24rem;
            height: 7.5rem;
          }
        }
        .ikuspegi {
          width: 10rem;
          height: 5rem;
          background-image: url(/img/ikuspegi.svg);
          background-size: contain;
          background-repeat: no-repeat;
          background-position: 50% 50%;
          margin-top: .5rem;
          @media (min-width: 1919px) {
            width: 15rem;
            height: 7.5rem;
          }
        }
      }
    }
  }

  .sideBar {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;
    flex: 1.2;
    margin: .5rem;
    padding: 1rem;
    background-color: #E2E8F0;
    h1 {
      font-weight: 400;
      font-size: 1.8rem;
      line-height: 1.1;
    }
    h3 {
      margin: .5rem 0 0.5rem;
      font-weight: 700;
      font-size: 1.2rem;
      line-height: 1.1;
    }
    hr {
      color: var(--btn-color);
    }
    .paraHolder {
      margin-top: 0.5rem;
      max-height: auto;
      overflow-y: scroll;
      @media (min-width: 480px) {
        max-height: 13.5rem;
      }
      @media (min-width: 1368px) {
        max-height: 18rem;
      }
      p {
        margin: .5rem 0 0.5rem;
        font-weight: 300;
        font-size: .72rem;
      }
    }
    @media (min-width: 640px) {
      flex: 1.2;
      margin: .5rem;
      padding: 1rem;
    }
  }

  .sideContent {
    margin-top: 1.5rem;
    @media (min-width: 640px) {
      margin-top: 0;
    }
  }

  .sideBtnBar {
    justify-content: flex-end;
  }

  .mapArea {
    position: relative;
    flex: 3;
    display: flex;
    flex-direction: column;
    margin-right: 0;
    padding: 0 1rem 1rem;
    @media (min-width: 640px) {
      flex: 3;
      display: flex;
      flex-direction: column;
      margin-right: .5rem;
      padding: .5rem 0 .5rem;
    }
  }

  svg {
    width: 100%;
    position: relative;
    display: flex;
    margin: 0 auto;
    align-self: center;
    @media (min-width: 640px) {
      flex: 1;
    }
  }

  .mapFoot {
    display: flex;
    flex-direction: column;
    @media (min-width: 640px) {
      flex-direction: row;
    }
  }

  .muniName {
    display: flex;
    flex: 1;
    margin: 0;
    align-self: center;
    text-align: center;
    font-size: 1rem;
    font-weight: 700;
    min-height: 2.5rem;
    padding: .5rem;
    @media (min-width: 640px) {
      align-self: flex-end;
      text-align: left;
    }
  }

  .logoHolder {
    display: flex;
    flex: 1;
    margin: 0 0 .5rem 0;
    align-self: center;
    justify-content: space-around;
    @media (min-width: 640px) {
      justify-content: flex-end;
    }
    .origami {
      width: 2rem;
      height: 2rem;
      background-image: url(/img/origami-logo.png);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      margin-top: .5rem;
      margin-right: 1rem;
      @media (min-width: 1919px) {
        width: 3rem;
        height: 3rem;
      }
    }
    .euskojaularitza {
      width: 10rem;
      height: 2rem;
      background-image: url(/img/hori_gv_bilingue.png);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      margin-top: .5rem;
      margin-right: 1rem;
      @media (min-width: 1919px) {
        width: 15rem;
        height: 3rem;
      }
    }
    .ikuspegi {
      width: 5rem;
      height: 2rem;
      background-image: url(/img/ikuspegi.svg);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      margin-top: .5rem;
      @media (min-width: 1919px) {
        width: 7.5rem;
        height: 3rem;
      }
    }
  }

  .state-borders {
    fill: none;
    stroke: #fff;
    stroke-width: .1rem;
    stroke-linejoin: round;
    stroke-linecap: round;
    pointer-events: none;
  }

  .back-rect {
    fill: none;
    pointer-events: all;
  }

  .autonomous_regions {
    fill: hsla(0, 100%, 50%, 0.2);
    stroke: none;
  }

  .provinces,
  .municipalities {
    // fill: var(--bg-color-alt);
    cursor: pointer;
    stroke: #fff;
    stroke-linecap: round;
    stroke-linejoin: round;
    &.Araba {
      // EA873C
      //fill: var(--bg-color-alt);
    }
    &.Gipuzkoa {
      // 3798A1
      //fill: var(--bg-color-alt);
    }
    &.Bizkaia {
      // 92050B;
      //fill: var(--bg-color-alt);
    }
    &:hover {
      //fill: var(--primary-color);
      opacity: .72;
    }
    &.active {
      opacity: .66;
      //fill: var(--bg-color-alt);
    }
  }

  .mesh {
    fill: none;
    stroke: #fff;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .label {
    fill: var(--font-color-alt);
    stroke: var(--font-color-dark);
    font-size: .072rem;
    stroke-width: 0.05;
    //text-shadow: .075rem .075rem .1rem var(--bg-color), -.075rem -.075rem .1rem var(--bg-color);
    cursor: pointer;
    font-weight: 700;
    display: none;
    &.active {
      display: block;
    }
  }

  .center-number-holder {
    &.hidden {
      display: none;
    }
  }

  .center-circle {
    display: none;
    fill: var(--font-color-alt);
    &.active {
      display: block;
    }
    &.zoomed {
      fill: var(--font-color);
      stroke: white;
    }
    &.hidden {
      display: none;
    }
  }

  .center-number {
    fill: var(--font-color);
    font-size: .050rem;
    //text-shadow: .075rem .075rem .1rem var(--bg-color), -.075rem -.075rem .1rem var(--bg-color);
    cursor: pointer;
    font-weight: 700;
    display: none;
    &.active {
      display: block;
    }
    &.zoomed {
      fill: var(--font-color-alt);
      //stroke: white;
    }
    &.hidden {
      display: none;
    }
  }

  .btnBar {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: .5rem;
  }

  button {
    cursor: pointer;
    &.active {
      opacity: .5;
    }
    &.active {
      color: white;
      background: var(--btn-color);
    }
  }

  .flex {
    button {
      flex: 2;
      width: 50%;
    }
  }

  .hexagon {
    //fill: red;
    //stroke: #fff;
    stroke-width: 1px;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .btn-bar {
    //white-space: nowrap;
    //word-break: break-word;
    &.flex-3 {
      flex: 2;
    }
  }

  .text-xs {
    font-size: .7rem !important;
  }

  .perc-btn {
    // display: inline-flex;
    max-width: 2.5rem;
  }

  .svg-rel {
    display: inline-flex;
    max-width: 3rem;
    min-width: 3rem;
    &.svg-cat {
      background: url(/svg/catolicos.svg) no-repeat center center;
      background-size: contain;
      width: 3rem !important;
    }
    &.svg-pro {
      background: url(/svg/protestantes.svg) no-repeat center center;
      background-size: contain;
      width: 3rem !important;
    }
    &.svg-ort {
      background: url(/svg/ortodoxos.svg) no-repeat center center;
      background-size: contain;
      width: 3rem !important;
    }
    &.svg-mus {
      background: url(/svg/musulmanes.svg) no-repeat center center;
      background-size: contain;
      width: 3rem !important;
    }
    &.svg-jud {
      background: url(/svg/judios.svg) no-repeat center center;
      background-size: contain;
      width: 3rem !important;
    }
    &.svg-hin {
      background: url(/svg/hinduistas.svg) no-repeat center center;
      background-size: contain;
      width: 3rem !important;
    }
    &.svg-bud {
      background: url(/svg/budistas.svg) no-repeat center center;
      background-size: contain;
      width: 3rem !important;
    }
    &.svg-otr {
      background: url(/svg/otras.svg) no-repeat center center;
      background-size: contain;
      width: 3rem !important;
    }
    &.svg-no {
      background: url(/svg/ateos.svg) no-repeat center center;
      background-size: contain;
      width: 3rem !important;
    }
  }

  .table {
    width: 100%;
    caption {
      text-align: left;
      border-top: 1px solid $black;
      border-bottom: 1px solid $black;
    }
    tr {
      border-bottom: 1px solid $black;
      &.inv {
        background-color: $black;
      }
    }
    th,
    td {
      text-align: center;
      font-size: .74rem;
      padding: .13rem;
      &.inv {
        color: $white;
      }
      &.tl {
        text-align: left;
      }
      &.eqw {
        width: 10rem;
      }
    }
  }

  .w-100 {
    width: 100%;
  }

  .w-2 {
    width: 2rem;
  }

  .w-8 {
    //max-width: 8rem;
    min-width: 8rem;
  }

  .infoIcon {
    width: 1.5rem;
    font-weight: 300;
    text-align: center;
    float: right;
    border-radius: 50%;
    border: 1px solid var(--font-color);
    cursor: pointer;
    &:hover {
      background-color: var(--font-color);
      color: $white;
    }
  }

</style>
